var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 47,
    viewBox: "0 0 48 47",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.871094,
    x2: 47.7878,
    y1: 23.3753,
    y2: 23.3753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m6.84674-.00878906h34.96546c3.2959 0 5.9613 2.67041906 5.9756 5.95489906v34.85829c0 3.2988-2.6797 5.9549-5.9756 5.9549h-10.0311v-.0425h.0027v-19.4073h5.7867l.0026-.0289v.0007l.7139-7.7546.0026-.0282h-6.2049v-3.1131c0-.1025.0047-.1997.0136-.2919.132-1.2449 1.0403-1.5506 1.7033-1.5506h4.3851v-.0282h.0026v-6.66894l-6.033-.02856c-6.0561 0-7.8757 4.0699-8.1668 7.2036-.0324.3391-.047.6674-.047.9787v3.4847h-3.8664v.0282h-.0027v7.7828h3.8978v19.4498h-17.12446c-3.31025 0-5.975646-2.6704-5.975646-5.9549v-34.84399c0-3.28448 2.679726-5.95489906 5.975646-5.95489906z",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e6550255e988ce7fd8cdb9400425d1e4.svg";
export { ForwardRef as ReactComponent };